<template>
    <step-section>
        <header class="step-section__header" slot="header">
            <h1 class="heading no-arrow heading-static">
                <b>{{ $t('summary') }}</b>
            </h1>
        </header>
        <div class="row">
            <div class="col-12 col-lg-7 col-xl-6">
                <div class="summary-content">
                    <div class="summary-item">
                        <h2 class="heading">
                            <template v-if="!editing">
                                {{ $t('configurationAdded') }}
                            </template>
                            <template v-else>
                                {{ $t('configurationUpdated') }}
                            </template>
                        </h2>
                        <div class="summary-item__content">
                            <figure
                                    class="item-block__img"
                                    v-if="windowTypeImage"
                            >
                                <img
                                        class="img-fluid"
                                        :src="windowTypeImage"
                                >
                            </figure>
                            <div class="item-content" :class="{'no-padding': !windowTypeImage}">
                <span class="title" v-if="form.name">
                  {{ form.name }}
                </span>
                                <span v-if="form.width && form.height">
                  <b>{{ form.width }}</b> x <b>{{ form.height }}</b>
                </span>
                                <span>
                  {{ $t('quantity') }}
                  <b>{{ form.count }} {{ $t('pieceUnit') }}</b>
                </span>
                                <div
                                        class="item-block__variants"
                                        v-if="colorsImages && colorsImages.length > 0"
                                >
                                    <span>{{ $t('color') }}:</span>
                                    <img
                                            class="variants-img"
                                            v-for="(imageUrl, index) in colorsImages"
                                            :key="`${index}-${imageUrl}`"
                                            :src="imageUrl"
                                    >
                                </div>
                            </div>
                            <div class="list" v-if="labels.length > 0">
                                <li
                                        v-for="(label, index) in labels"
                                        :key="index"
                                >
                                    {{ label }}
                                </li>
                            </div>
                        </div>
                    </div>
                    <button
                            type="button"
                            class="summary-btn summary-btn--edit"
                            @click="handleDuplicate"
                    >
                        <span class="icon icon-copy-content"></span>
                        <span>{{ $t('duplicateAndEdit') }}</span>
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-5 col-xl-6 d-flex-custom">
                <button
                        type="button"
                        class="summary-btn summary-btn--edit summary-btn--edit-desktop"
                        @click="handleDuplicate"
                >
                    <span class="icon icon-copy-content"></span>
                    <span>{{ $t('duplicateAndEdit') }}</span>
                </button>
                <button
                        type="button"
                        class="summary-btn summary-btn--white"
                        @click="handleAddNew"
                >
                    <span class="icon icon-add-plus-button"></span>
                    <span>{{ $t('addNew') }}</span>
                </button>
                <button
                        type="button"
                        class="summary-btn summary-btn--base"
                        v-if="hasConfigurations"
                        @click="openOrderQuoteModal"
                >
                    <span class="icon icon-file"></span>
                    <span>{{ $t('orderQuote') }}</span>
                </button>
            </div>
        </div>
    </step-section>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import stepMixin from './stepMixin'

  export default {
    name: 'SummaryStep',
    mixins: [stepMixin],
    metaInfo () {
      const { companyInfo, $t } = this
      return {
        title: $t('summary') + ' | ' + companyInfo.seo_title + ' | ' + $t('titleWindowConfigurator'),
      }
    },
    methods: {
      ...mapActions({
        openOrderQuoteModal: 'openOrderQuoteModal',
        openConfigurator: 'configurator/open',
        cloneConfiguration: 'cloneConfiguration',
      }),
      handleAddNew () {
        this.openConfigurator({ type: this.configurationType })
      }
      ,
      async handleDuplicate () {
        const { form, cloneConfiguration, $router } = this

        if (!form.id) {
          throw new Error('Form id is empty')
        }

        const newConfiguration = await cloneConfiguration(form.id)

        if (newConfiguration && newConfiguration.id) {
          $router.push({
            to: 'configurator',
            query: {
              type: this.configurationType,
              id: newConfiguration.id,
            },
          })
        }
      }
      ,
    }
    ,
    computed: {
      ...mapState({
        configurationType: state => state.configurationType,
        form: state => state.configurator.form,
        companyInfo: state => state.companyInfo
      }),
      ...mapGetters({
        hasConfigurations: 'hasConfigurations',
        editing: 'configurator/editing',
      }),
      windowTypeImage () {
        const { form: { windowType = {} } } = this
        return windowType.photo || null
      }
      ,
      colorsImages () {
        const { colorInner, colorOuter } = this.form

        const colors = []

        if (colorInner.photo) {
          colors.push(colorInner.photo)
        }

        if (colorOuter.photo) {
          colors.push(colorOuter.photo)
        }

        return colors
      }
      ,
      labels () {
        const {
          style = {},
          material = {},
          profile = {},
          safety = {},
          windowType = {},
          windowOpeningType = {},
          innovations = [],
        } = this.form
        const labels = []

        if (style.name) {
          labels.push(style.name)
        }

        if (material.name) {
          labels.push(material.name)
        }

        if (profile.name) {
          labels.push(profile.name)
        }

        if (windowType.name) {
          labels.push(windowType.name)
        }

        if (windowOpeningType.name) {
          labels.push(windowOpeningType.name)
        }

        if (safety.name) {
          labels.push(safety.name)
        }

        if (innovations.length > 0) {
          innovations.forEach(innovation => {
            labels.push(innovation.name)
          })
        }

        return labels
      }
      ,
    }
  }

</script>
